import React from "react";
import AdminNavbar from "../../modules/admin/AdminNavbar";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import ApplicantTab from "./examRoom/ApplicantTab";
import CandidateTab from "./examRoom/CandidateTab";
import MailTab from "./examRoom/MailTab";
import MessageTab from "./examRoom/MessageTab";
import RaterTab from "./examRoom/RaterTab";
import RaterResultTab from "./examRoom/RaterResultTab";
import Settings from "./examRoom/Settings";
import { useRecoilValue } from "recoil";
import { isTestroomNameState } from "../../../recoil/admin/examRoom";
import { testRoomSnState } from "../../../recoil/auth";
import Xlsx from "../../../api/hooks/xlsx";
import dayjs from "dayjs";
// 그룹이름_평가결과_년월일

const AdminExamRoom = ({ isPageStep, setPageStep, searchTestRoom }) => {
  const testroomName = useRecoilValue(isTestroomNameState);
  const isTestRoomSn = useRecoilValue(testRoomSnState);
  const { getDownloadResult } = Xlsx();
  return (
    <div>
      <link rel="stylesheet" type="text/css" href="/css/admin.css" />
      <AdminNavbar />
      <div className="admin_content">
        <div className="content-title">
          <p className="exam">
            시험실 {">"} {testroomName}
          </p>
        </div>
        <div className="content-cont">
          <div className="container">
            <Tabs selectedTabClassName="active">
              <TabList className="nav nav-tabs">
                <Tab className="nav nav-link">신청자</Tab>
                <Tab className="nav nav-link">응시자</Tab>
                <Tab className="nav nav-link">메일전송</Tab>
                {/* <Tab className="nav nav-link">문자전송</Tab> */}
                <Tab className="nav nav-link">평가자</Tab>
                <Tab className="nav nav-link">시험실설정</Tab>
                <button
                  style={{ padding: "0" }}
                  className="nav nav-link"
                  onClick={() => {
                    getDownloadResult(
                      isTestRoomSn,
                      `${testroomName}_평가결과_${dayjs().format("YYYYMMDD")}`
                    );
                  }}
                >
                  평가결과 <br></br>다운로드
                </button>
              </TabList>
              <TabPanel>
                <ApplicantTab />
              </TabPanel>
              <TabPanel>
                <CandidateTab />
              </TabPanel>
              <TabPanel>
                <MailTab />
              </TabPanel>
              {/* <TabPanel>
                <MessageTab />
              </TabPanel> */}
              <TabPanel>
                <RaterTab />
              </TabPanel>
              <TabPanel>
                <Settings />
              </TabPanel>
              {/* <TabPanel>
                <RaterResultTab />
              </TabPanel> */}
            </Tabs>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminExamRoom;
